import React, { Component } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { Container } from "reactstrap";
import config from "../../config";

import RequestManager from "../../singletons/RequestManager";

import {
  // AppFooter,
  AppHeader,
  AppSidebar,
  AppSidebarFooter,
  AppSidebarForm,
  AppSidebarHeader,
  AppSidebarMinimizer,
  AppSidebarNav
} from "@coreui/react";
// sidebar nav config
import navigation from "../../_nav";
// routes config
import routes from "../../routes";
// import DefaultFooter from "./DefaultFooter";
import DefaultHeader from "./DefaultHeader";
import {generateHeaders, generateHeaderswithBasicAuthToken, generateEpochTimestamp, generateSignature} from "../../utils/helper";
class DefaultLayout extends Component {
  render() {
    let storeDetails = localStorage.getItem("storeInformation");
    let resetpwd = localStorage.getItem('resetpwd');
    
    if (!storeDetails) {
      if (resetpwd) {
        console.log('from default',resetpwd );
       
      }else{
      return <Redirect to="/login" />;
      }
    }

    return (
      <div className="app">
        <AppHeader fixed>
          <DefaultHeader onLogout={this.logoutUser} />
        </AppHeader>
        <div className="app-body">
          <AppSidebar fixed display="lg">
            <AppSidebarHeader />
            <AppSidebarForm />
            <AppSidebarNav navConfig={navigation} {...this.props} />
            <AppSidebarFooter />
            <AppSidebarMinimizer />
          </AppSidebar>
          <main className="main">
            <Container fluid className="p-0">
              <Switch>
                {routes.map((route, idx) => {
                  return route.component ? (
                    <Route
                      key={idx}
                      path={route.path}
                      exact={route.exact}
                      name={route.name}
                      render={props => <route.component {...props} />}
                    />
                  ) : null;
                })}
              </Switch>
            </Container>
          </main>
          {/* <AppAside fixed hidden>
            <DefaultAside />
          </AppAside> */}
        </div>
        {/* <AppFooter>
          <DefaultFooter />
        </AppFooter> */}
      </div>
    );
  }

  logoutUser = async () => {
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    let authToken = storeInformation.token;
    var vtimestamp = generateEpochTimestamp();

    await fetch(config.getHost() + "/api/account/logout", {
      method: "POST",
      headers: {
        Authorization: "Token " + authToken,
        Timestamp: vtimestamp,
        Signature: generateSignature(vtimestamp, authToken)         
      }
    });

    let requestManager = new RequestManager();
    requestManager.clearClient();

    localStorage.removeItem("reloadActive");
    localStorage.removeItem("storeInformation");
    localStorage.removeItem("loginModeAccess");

    localStorage.removeItem("loginMode");
    localStorage.removeItem("attendedOrders");
    localStorage.removeItem("attendedSOSOrders");
    localStorage.removeItem("printedOrders");
    localStorage.removeItem("resetpwd");
    this.props.history.push("/login");
  };
}

export default DefaultLayout;



// WEBPACK FOOTER //
// ./src/containers/DefaultLayout/DefaultLayout.js